/**
 * Ajuste de catálogo ERNA/Fusión: Stage puede traer «ZARA MAN» genérico y ERNA
 * pedidos «ZARA MAN ZERO» / «ZARA MAN TREND». Quitamos el padre ambiguo si hay sub-marcas
 * (el volumen de pedidos vive en ZERO, no en la fila ZARA MAN de Stage).
 */

export const usesMarcaCatalogoAjuste = (vista) => {
  const v = String(vista || "").toLowerCase();
  return v === "erna" || v === "fusion";
};

export const marcasForVista = (marcas, vista) => {
  const list = Array.isArray(marcas) ? marcas : [];
  if (!usesMarcaCatalogoAjuste(vista)) {
    return [...list].sort((a, b) => a.localeCompare(b, "es"));
  }

  const set = new Set(
    list.map((m) => String(m || "").trim()).filter(Boolean),
  );

  const zaraSubmarcas = [...set].filter(
    (m) => /^ZARA MAN\s+/i.test(m) && !/^ZARA MAN$/i.test(m),
  );
  if (zaraSubmarcas.length > 0) {
    set.delete("ZARA MAN");
  }

  return Array.from(set).sort((a, b) => a.localeCompare(b, "es"));
};
